<div id="{{'esignModal'+scope}}" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  class="modal full-modal esign-modal fade" style="position: absolute;">
  <div class="modal-dialog">
    <div class="modal-content" style="padding-top: 0px;">
      <div class="modal-header" style="position: relative;">
        <button type="button" (click)="closePanel()" aria-label="Close" class="close">
          <span aria-hidden="true"></span>
        </button>
        <div class="modal-container">
          <div class="row">
            <div class="col-sm-8">
              <h4 id="{{'myModalLabel'+scope}}" class="modal-title">{{bs.getResource('rbkey_RsnFrdReAttmptRqstLBL')}}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="main-section">
        <div class="inner-section">
          <div>
            {{parentNodeName}}<span *ngIf="parentNodeName.length>0">>></span><span style="word-wrap: break-word;">{{NodeName}}</span>
          </div>
          <div style="padding: 10px 10px 10px 0px">
            <input id="{{'txtRttmptsRqstRsn'+scope}}" type="text" class="form-control"> </div>
          <div class="first-row no-border-b float-right">
            <div class="bottom-buttons">
              <button type="button" id="{{'btnAccept'+scope}}" class="cancel-btn"
                (click)="ResetNodeReAttemptsRequest()">{{bs.getResource('rbkey_SbmtLBL')}}</button>
              <button type="button" class="cancel-btn"
                (click)="closePanel()">{{bs.getResource('rbkey_CnclLBL')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>